import Instance from "../../../../Axios";

// New Actions for the app

const GetObrasAHDProjetosPenalizadosIniciados = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/penalizadosIniciados`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({
        type: "GET_OBRAS_AHD_PROJETOS_PENALIZADOS_INICIADOS",
        payload: data.yData[0].total,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasAHDProjetosPenalizadosIniciados;
